import {createTheme } from '@mui/material/styles';  
import { useMediaQuery } from '@mui/material';
import { border, margin, padding } from '@mui/system';
const darkMode = true;

const AppTheme = createTheme({
  
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: {
        main: '#F3D45E',
        light: '#42a5f5',
        dark: '#1565c0',
        contrastText: '#fff',
      },
      secondary:{
        main: '#FFFFFF',
      },
      background: {
        default: darkMode ? '#180D2B' : '#fff', // Set your default background color
      },
    },
    typography: {
      fontFamily: 'Cardium B',
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            backgroundColor: '#F3D45E', // Set your common button background color
            fontFamily: 'Cardium B', 
            textTransform: 'none',
            color: '#241E41', // Set your button text color
            '&:hover': {
              backgroundColor: '#C49D09', // Set the hover background color
            },
          },
        },
      },
      MuiContainer: {
        styleOverrides: {
          root: {
            paddingLeft: 0, 
            paddingRight: 0,
            width : "100%"  
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            fontSize: 12,
            fontWeight: 200,
            lineHeight: 18,
          }
        }
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundImage: "linear-gradient(90.79deg, #260F0E -24.95%, #24183B 33.25%, #741515 96.46%)",
            backgroundColor: "transparent", // optional, fallback or to override default
          },
        },
      },

      MuiRadio: {
        styleOverrides: {
          root: {
            '&.Mui-checked': {
              color: '#F74542',
            }
          },
        },
      },
      MuiFormLabel: {
        '&.Mui-focused': {
          color: '#FFFFFF',
        }
      },
      MuiListItemButton: {
        root: {
          '&.Mui-selected': {
            color: '#241E41',
            backgroundColor: '#F3D45E',
          },
        },
      }, 
     /* MuiTypography: {
        fontFamily: "Cardium B",
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 200,
        lineHeight: 18, 
      },*/
      MuiGrid2: {
        defaultProps: {
          disableEqualOverflow: true,
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          padding : "0px 0px",
          option : {
            backgroundColor : "#ffffff",
            color : "#000000",
            "&.MuiAutocomplete-option" : {
              backgroundColor : "#ffffff !important"
            },
            "&.Mui-focused" : {
              backgroundColor : "#F3D45E !important",
            },
          },
          popupIndicator: {
            color: '#F3D45E',
          },
          root: {
            '&.Mui-selected': {
              color: '#fff',
              backgroundColor: '#000000',
            },
            height : "100px"
          },
        }
      },
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            scrollbarColor: "#6b6b6b #2b2b2b",
            "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
              backgroundColor: "#2b2b2b",
              width: 2,
            },
            "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
              borderRadius: 8,
              backgroundColor: "#6b6b6b",
              minHeight: 24,
              border: "1px solid #2b2b2b",
            },
            "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
              backgroundColor: "#959595",
            },
            "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
              backgroundColor: "#959595",
            },
            "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#959595",
            },
            "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
              backgroundColor: "#2b2b2b",
            },
          },
        },
      },
    },
  });
  export default AppTheme;